/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Material } from '../models/Material';
import type { MaterialResponse } from '../models/MaterialResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class MaterialService {
    /**
     * @param materialId The id of the material to delete
     * @returns void
     * @throws ApiError
     */
    public static deleteMaterial(
        materialId: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/material/{materialId}',
            path: {
                'materialId': materialId,
            },
            errors: {
                404: `No material found with the specified id`,
            },
        });
    }
    /**
     * @returns MaterialResponse The currently available materials
     * @throws ApiError
     */
    public static getMaterials(): CancelablePromise<MaterialResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/material',
        });
    }
    /**
     * @param requestBody
     * @returns Material Add a new material
     * @throws ApiError
     */
    public static postMaterial(
        requestBody: Material,
    ): CancelablePromise<Material> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/material',
            body: requestBody,
            mediaType: 'application/json',
        });
    }
}
